import config from '../utils/config';

export interface AuthGuardResource {
  ResourceId: string;
  ResourceType: string;
  Permissions: {
    Admin?: boolean;
    [key: string]: any;
  };
}

export interface AuthGuardProfile {
  GlobalSettings: {
    Language: string;
    TimeZone: string;
    Country: string;
  };
  PersonalInformation: {
    FirstName: string;
    LastName: string;
    Email: string;
  };
  ProfileId: string;
  AccessType: string;
  ProfileName: string;
  ProfileNameLowercase: string;
  CreatedDate: string;
  Resources: AuthGuardResource[];
  ModifiedDate: string;
}

/**
 * Fetches user profile from AuthGuard API
 * @param profileId - The profile ID from the JWT token
 * @param accessToken - The AuthGuard access token
 * @returns Promise<AuthGuardProfile>
 */
export const fetchAuthGuardProfile = async (
  profileId: string,
  accessToken: string
): Promise<AuthGuardProfile> => {
  const backendBase = config.api.snowflake;
  const response = await fetch(`${backendBase}/api/v1/auth/profile/${profileId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch AuthGuard profile: ${response.status}`);
  }

  return await response.json();
};

/**
 * Checks if the user has admin permissions for the TotalSERP application
 * @param profile - The AuthGuard profile
 * @returns boolean - True if user has admin permissions
 */
export const hasAdminPermission = (profile: AuthGuardProfile | null): boolean => {
  if (!profile || !profile.Resources) {
    return false;
  }

  // Find the totalserp resource
  const totalSerpResource = profile.Resources.find(
    (resource) => resource.ResourceId.toLowerCase().includes('serp')
  );

  if (!totalSerpResource || !totalSerpResource.Permissions) {
    return false;
  }

  // Check if Admin permission exists and is true
  return totalSerpResource.Permissions.Admin === true;
};



